import { render, staticRenderFns } from "./WidgetAgencyActiveSegment.vue?vue&type=template&id=d97b502a"
import script from "./WidgetAgencyActiveSegment.vue?vue&type=script&lang=js"
export * from "./WidgetAgencyActiveSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports